/**
 * LandingHero — Hero-Section der öffentlichen Landingpage (W4.2)
 *
 * Entspricht dem Layout aus heliumtracker_design_prototpye/welcome.html:
 * Links: Headline, Sub-Headline, CTA-Buttons, Social-Proof-Zahlen
 * Rechts: Beispiel-Dashboard-Card (statisch, ausdruecklich als Beispiel beschriftet)
 *
 * Social-Proof-Zahlen: gerundete, belegbare Bestandswerte (DB-Stand 04.09.2026:
 * 91.575 Nutzer, 757.137 Hotspots, 66.136 online) — keine erfundenen KPIs, keine
 * Uptime-Behauptung. Werte liegen in landing.json, damit sie pflegbar bleiben.
 */
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function LandingHero() {
  const { t } = useTranslation('landing')

  return (
    <section className="landing-hero" data-testid="landing-hero">
      <div className="landing-hero__left">
        <span className="pill pill-primary">
          <span className="dot" />
          {t('hero.pill')}
        </span>

        <h1 className="landing-hero__headline">{t('hero.headline')}</h1>

        <p className="landing-hero__sub">{t('hero.sub')}</p>

        <div className="landing-hero__actions">
          <Link to="/register" className="btn btn-primary btn-lg">
            {t('hero.cta.start')}
          </Link>
          <Link to="/login" className="btn btn-lg">
            {t('hero.cta.login')}
          </Link>
        </div>

        <div className="landing-hero__stats">
          <div className="landing-hero__stat">
            <strong>{t('hero.stats.operatorsValue')}</strong>
            <span>{t('hero.stats.operators')}</span>
          </div>
          <div className="landing-hero__stat">
            <strong>{t('hero.stats.hotspotsTrackedValue')}</strong>
            <span>{t('hero.stats.hotspotsTracked')}</span>
          </div>
          <div className="landing-hero__stat">
            <strong>{t('hero.stats.hotspotsOnlineValue')}</strong>
            <span>{t('hero.stats.hotspotsOnline')}</span>
          </div>
        </div>
      </div>

      <div className="landing-hero__right">
        <div className="card landing-hero__card">
          <div className="landing-hero__card-header">
            <div>
              <div className="landing-hero__card-label">{t('hero.card.label')}</div>
              <div className="landing-hero__card-name">{t('hero.card.name')}</div>
              <div className="landing-hero__card-meta">{t('hero.card.meta')}</div>
            </div>
            <span className="pill pill-success">
              <span className="dot" />
              {t('hero.card.onlinePill')}
            </span>
          </div>
          <div className="grid grid-2" style={{ marginTop: 20 }}>
            <div className="kpi" style={{ padding: 14 }}>
              <div className="kpi-label">{t('hero.card.kpiLabel24h')}</div>
              <div className="kpi-value tnum" style={{ fontSize: 22 }}>
                0,244
              </div>
              <div className="kpi-sub kpi-up">{t('hero.card.trendVsAvg')}</div>
            </div>
            <div className="kpi" style={{ padding: 14 }}>
              <div className="kpi-label">{t('hero.card.kpiLabelUsd')}</div>
              <div className="kpi-value tnum" style={{ fontSize: 22 }}>
                $1,26
              </div>
              <div className="kpi-sub muted">{t('hero.card.sampleValues')}</div>
            </div>
          </div>
          <div className="landing-hero__card-note">{t('hero.card.note')}</div>
        </div>
      </div>
    </section>
  )
}
